import { useFormik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { Form, FormFeedback, Input, Label, Spinner } from 'reactstrap';
import * as Yup from 'yup';
import { mins2Str } from '../../helpers/myFunctions';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const SmsCode = ({ user_id, toggle }) => {
    const { t } = useTranslation();

    // Fallback qo‘shildi, agar Common reduceri mavjud bo‘lmasa
    const { isForDemo = false, price = 0 } = useSelector(state => state.Common || {});

    const [timer, setTimer] = useState('1:59');
    const [finished, setFinished] = useState(false);
    const [smsAgain, setSmsAgain] = useState(false);
    const [loading, setLoading] = useState(false);

    let intervalRef = useRef(null);

    useEffect(() => {
        if (document.getElementById('code')) {
            document.getElementById('code').focus();
        }

        let seconds = 119;
        intervalRef.current = setInterval(() => {
            seconds--;
            if (seconds === 0) {
                clearInterval(intervalRef.current);
                setFinished(true);
                clearCode();
            }
            setTimer(mins2Str(seconds));
        }, 1000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [smsAgain]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            code: '',
        },
        validationSchema: Yup.object().shape({
            code: Yup.number()
                .typeError(t('t-enter-sms-code-helper')) // Noto‘g‘ri format uchun xabar
                .required(t('t-enter-sms-code-helper')),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const response = await fetch('https://online.hrplus.uz/confirm-advert-sms-code', {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json',
                        'login': 'HRplus+',
                        'password': 'Ctc0oTYayc77z',
                    },
                    body: JSON.stringify({
                        code: values.code,
                        user_id: user_id,
                        data: { isForDemo, price }, // Data ob'ektini to‘g‘ri shakllantirish
                    }),
                });

                const result = await response.json();
                if (result.error) {
                    toast.error(t('t-server-error'));
                } else if (!result.status) {
                    toast.warn(t('t-code-incorrect'));
                } else {
                    localStorage.setItem('HR_USER_ID', user_id);
                    toggle(2);
                }
            } catch (err) {
                console.log(err);
                toast.error(t('t-server-error'));
            } finally {
                setLoading(false);
            }
        },
    });

    const clearCode = () => {
        fetch('https://online.hrplus.uz/delete-advert-sms-code?id=' + user_id, {
            method: 'DELETE',
            headers: {
                'Content-type': 'application/json',
                'login': 'HRplus+',
                'password': 'Ctc0oTYayc77z',
            },
        })
            .catch(err => console.log(err));
    };

    const sendSmsCodeAgain = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://online.hrplus.uz/send-advert-sms-code-again?id=' + user_id, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'login': 'HRplus+',
                    'password': 'Ctc0oTYayc77z',
                },
            });

            const result = await response.json();
            if (result.status) {
                setTimer('1:59');
                setFinished(false);
                setSmsAgain(state => !state);
            } else {
                toast.error(t('t-server-error'));
            }
        } catch (err) {
            console.log(err);
            toast.error(t('t-server-error'));
        }
    };

    return (
        <React.Fragment>
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
                className="needs-validation"
                action="#"
            >
                <div className="mb-2">
                    <Label htmlFor="code" className="form-label fs-17 text-center w-100">{t('t-sms-code')}</Label>
                    <Input
                        id="code"
                        name="code"
                        type="number"
                        className="text-center place-center"
                        placeholder={t('t-enter-sms-code')}
                        onChange={validation.handleChange}
                        value={validation.values.code || ''}
                        invalid={validation.touched.code && validation.errors.code ? true : false}
                    />
                    {validation.touched.code && validation.errors.code ? (
                        <FormFeedback type="invalid"><div>{validation.errors.code}</div></FormFeedback>
                    ) : null}
                </div>
                <div className="mt-3 text-center">
                    {finished ? (
                        <Link
                            to="#"
                            onClick={sendSmsCodeAgain}
                            className="btn-link fs-14 text-decoration-underline"
                        >
                            {t('t-resend-sms-code')}
                        </Link>
                    ) : (
                        <p className="mb-0 text-danger d-inline-flex fs-15 gap-1 align-items-center" style={{ width: 55 }}>
                            <i className="ri-timer-line fs-17"></i> {timer}
                        </p>
                    )}
                </div>
                <div className="mt-4">
                    <button
                        className="btn btn-success w-100 d-flex align-items-center gap-2 justify-content-center"
                        type="submit"
                        disabled={loading}
                    >
                        {loading && <Spinner style={{ height: 18, width: 18 }} />} {t('t-comfirm')}
                    </button>
                </div>
            </Form>
        </React.Fragment>
    );
};

export default SmsCode;